import React from "react";
import PropTypes from "prop-types";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { Icon } from "rbx";
import {
  Header,
  Title,
  SubTitle,
  TabLink
} from "../styles/StyledSectionHeader";

const StyledSection = styled.section`
  ${Header} {
    display: flex;
    justify-content: space-between;
  }
  &:not(:last-child) {
    margin-bottom: 0.75rem;
  }
  hr {
    &:last-child {
      background: transparent;
    }
  }
`;

function Section({ title, subtitle, links, size, children }) {
  return (
    <StyledSection>
      <Header size={size}>
        <Title>{title}</Title>
        <SubTitle>{subtitle}</SubTitle>
        {links.length
          ? links.map((link, k) =>
              link.content ? (
                <React.Fragment key={k}>{link.content}</React.Fragment>
              ) : (
                <TabLink {...link.props} key={k} onClick={link.action}>
                  <Icon size="small" style={{ marginRight: "0.25rem" }}>
                    <FontAwesomeIcon fixedWidth icon={link.icon} />
                  </Icon>
                  <span>{link.text}</span>
                </TabLink>
              )
            )
          : null}
      </Header>
      {children}
    </StyledSection>
  );
}

Section.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.node,
  links: PropTypes.array,
  size: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};

Section.defaultProps = {
  links: []
};
export default Section;
